const s = {
  name: "PosAndroid",
  dimensions: { width: 28, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 28 39.7" style="enable-background:new 0 0 28 39.7;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M8,13c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2S6.8,11,6.8,11.7C6.8,12.4,7.3,13,8,13z"/>
		<path class="st0" d="M21.3,11.7c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C20.7,10.5,21.3,11,21.3,11.7
			z"/>
		<path class="st0" d="M5.7,0l3.5,3.5C10.7,3,12.3,2.7,14,2.7s3.3,0.3,4.8,0.8L22.3,0l1.4,1.4l-3,3c4.3,2.4,7.3,7,7.3,12.3v23h-2
			v-21H2v21H0v-23c0-5.3,2.9-9.9,7.3-12.3l-3-3L5.7,0z M26,16.7c0-6.6-5.4-12-12-12c-6.6,0-12,5.4-12,12H26z"/>
		<path class="st0" d="M9,24.7c0-1.7,1.3-3,3-3h4c1.7,0,3,1.3,3,3v8c0,1.7-1.3,3-3,3h-4c-1.7,0-3-1.3-3-3V24.7z M12,23.7
			c-0.5,0-1,0.5-1,1v3h6v-3c0-0.5-0.5-1-1-1H12z M11,29.7v3c0,0.5,0.5,1,1,1h4c0.5,0,1-0.5,1-1v-3H11z"/>
		<path class="st0" d="M11,39.7v-2h6v2H11z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as PosAndroid
};
